import fetchWrapper from "@/api/fetch-wrapper";

export const getOrganizationInfo = (inn) => {
    const query = `ajax/companyIntegrationDadata.php?inn=${inn}`;
    return fetchWrapper.get(query)
}